const NearEarthObjectRadarMonitor = () => {
    return (<>
        <div className="monitor neo">

        </div>
    </>);
}

export default NearEarthObjectRadarMonitor;